/** Synchronizes the homepage journey image with the paragraph at the reading line. */
export function initHomeJourney(): void {
  const journey = document.querySelector<HTMLElement>('[data-journey]')
  if (!journey) return

  const steps = Array.from(journey.querySelectorAll<HTMLParagraphElement>('[data-journey-copy] > p'))
  const images = Array.from(journey.querySelectorAll<HTMLImageElement>('[data-journey-image]'))
  const place = journey.querySelector<HTMLElement>('[data-journey-place]')
  const current = journey.querySelector<HTMLElement>('[data-journey-current]')
  const places = [
    'Loess Plateau',
    'East China Sea',
    'West Lake',
    'Chengdu',
  ]
  if (steps.length === 0 || images.length !== steps.length) return

  steps.forEach((step, index) => step.dataset.journeyStep = String(index))

  let activeIndex = -1
  let visible = true
  let scheduled = false

  const render = (index: number): void => {
    if (index === activeIndex && journey.classList.contains('is-motion-ready')) return
    activeIndex = index

    steps.forEach((step, stepIndex) => step.classList.toggle('is-active', stepIndex === index))
    images.forEach((image, imageIndex) => {
      const active = imageIndex === index
      image.classList.toggle('is-active', active)
      image.setAttribute('aria-hidden', String(!active))
    })
    if (place) place.textContent = places[index]
    if (current) current.textContent = String(index + 1).padStart(2, '0')
    journey.style.setProperty('--journey-progress', String(index / (steps.length - 1)))
  }

  const update = (): void => {
    if (!visible) return
    const readingLine = window.innerHeight * .5
    let nearest = 0
    let nearestDistance = Number.POSITIVE_INFINITY

    steps.forEach((step, index) => {
      const rect = step.getBoundingClientRect()
      const center = rect.top + rect.height / 2
      const distance = Math.abs(center - readingLine)
      if (distance < nearestDistance) {
        nearest = index
        nearestDistance = distance
      }
    })

    render(nearest)
  }

  const scheduleUpdate = (): void => {
    if (scheduled) return
    scheduled = true
    window.requestAnimationFrame(() => {
      update()
      scheduled = false
    })
  }

  window.requestAnimationFrame(() => {
    journey.classList.add('is-motion-ready')
    render(0)
    update()
  })

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      visible = entries[0].isIntersecting
      if (visible) scheduleUpdate()
    }, { rootMargin: '20% 0px' })
    observer.observe(journey)
  }

  window.addEventListener('scroll', scheduleUpdate, { passive: true })
  window.addEventListener('resize', scheduleUpdate)
}
